'use strict';

var _makemodelyears = require('../core/makemodelyears');

var _makemodelyears2 = _interopRequireDefault(_makemodelyears);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_makemodelyears2.default.init();

// shows/hides mmy not available card
var hideNotAvailable = function hideNotAvailable(isHidden) {
  document.querySelectorAll('[data-variant-not-available]').forEach(function (notAvailable) {
    notAvailable.classList.toggle('hide', isHidden);
  });
};

// disables and fades out companion product area
var disableCompanions = function disableCompanions(isDisabled) {
  var companionsEl = document.querySelector('[data-companion-selector]');
  var mobileNextBtn = document.querySelector('[data-mobile-goto-variants]');

  companionsEl && companionsEl.classList.toggle('disabled', isDisabled);

  if (mobileNextBtn) {
    mobileNextBtn.disabled = isDisabled;
  }
};

var hideVariants = function hideVariants(isHidden) {
  var variantsEl = document.querySelector('[data-variant-selector]');
  var startingAtPrice = document.querySelector('[data-form-meta-mmy]');

  variantsEl && variantsEl.classList.toggle('hide', isHidden);
  startingAtPrice && startingAtPrice.classList.toggle('hide', !isHidden);
};

var bindMMYSelects = function bindMMYSelects() {
  var mmyContainer = document.querySelector('[data-product-mmy]');
  if (!mmyContainer) return;

  var selectMake = mmyContainer.querySelector('#make');
  var selectModel = mmyContainer.querySelector('#model');
  var selectYear = mmyContainer.querySelector('#year');

  if (!selectMake || !selectModel || !selectYear) return;

  selectMake.addEventListener('change', function () {
    disableCompanions(true);
    hideVariants(true);
    hideNotAvailable(true);
  });

  selectModel.addEventListener('change', function () {
    disableCompanions(true);
    hideVariants(true);
    hideNotAvailable(true);
  });

  selectYear.addEventListener('change', function () {
    window.byb = window.byb || {};

    window.byb.make = selectMake.value;
    window.byb.model = selectModel.value;
    window.byb.year = selectYear.value;

    var selectedMmy = window.byb.make + '--' + window.byb.model + '--' + window.byb.year;
    var excludedMmyCsv = mmyContainer.getAttribute('data-excluded-mmy').split(',');
    var isExcluded = excludedMmyCsv.includes(selectedMmy);

    disableCompanions(isExcluded);
    hideVariants(isExcluded);
    hideNotAvailable(!isExcluded);

    var mmyChangedEvent = new Event('MMY_CHANGED');
    document.dispatchEvent(mmyChangedEvent);

    // Setup Url for Typeform
    var typeForm = document.querySelector('[data-notify-me]');
    var url = typeForm.getAttribute('href');
    typeForm.setAttribute('href', url + '&make=' + window.byb.make + '&model=' + window.byb.model + '&year=' + window.byb.year);
    var qs,
        js,
        q,
        s,
        d = document,
        gi = d.getElementById,
        ce = d.createElement,
        gt = d.getElementsByTagName,
        id = "typef_orm_share",
        b = "https://embed.typeform.com/";if (!gi.call(d, id)) {
      js = ce.call(d, "script");js.id = id;js.src = b + "embed.js";q = gt.call(d, "script")[0];q.parentNode.insertBefore(js, q);
    };
  });
};

document.addEventListener('DOMContentLoaded', function () {
  bindMMYSelects();
});

document.addEventListener('shopify:section:load', function () {
  bindMMYSelects();
});